import { useEffect, useRef } from 'react';

import { useGetChannelAccessQuery } from 'src/services/dashboard-api';
import { dashboardApi } from 'src/services/dashboard-api/dashboardApi';
import { useAppDispatch } from 'src/store/hooks';

export default function ChannelAccessSync({
  onChange,
}: {
  onChange: () => void;
}) {
  const dispatch = useAppDispatch();
  const { data } = useGetChannelAccessQuery(undefined, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });
  const previous = useRef<string>();

  useEffect(() => {
    if (!data) {
      return;
    }
    const next = JSON.stringify(data);
    if (previous.current !== undefined && previous.current !== next) {
      dispatch(dashboardApi.util.invalidateTags(['ChannelAccess']));
      onChange();
    }
    previous.current = next;
  }, [data, dispatch, onChange]);

  return null;
}
